import { render, staticRenderFns } from "./serveCarousel.vue?vue&type=template&id=564f08df&scoped=true&"
import script from "./serveCarousel.vue?vue&type=script&lang=js&"
export * from "./serveCarousel.vue?vue&type=script&lang=js&"
import style0 from "./serveCarousel.vue?vue&type=style&index=0&id=564f08df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f08df",
  null
  
)

export default component.exports